interface GuidelinesTextTextProps {
    system?: string;
}

const GuidelinesText = ({ system = "Paçoca" }: GuidelinesTextTextProps) =>{
    return (
        <div style={{textAlign: "justify"}}>
            <p>Última atualização: 12/09/2024</p>

            <h5>Aceitação dos Termos</h5>
            <p>
                Ao utilizar a {system}, você concorda integralmente com estes Termos de Uso e com nossa Política de Privacidade.
                <strong> Ao criar uma conta, você declara que leu, entendeu e ACEITA todos os termos aqui descritos, incluindo o tratamento de dados pessoais conforme a LGPD.</strong> 
                Caso não concorde, não prossiga com o cadastro e interrompa o uso da plataforma.
            </p>

            <h5>Modificações nos Termos</h5>
            <p>
                A {system} pode atualizar estes Termos a qualquer momento. Notificações poderão ser enviadas por e-mail, alertas no aplicativo ou ao acessar novamente a plataforma.
            </p>

            <h5>Elegibilidade</h5>
            <p>
                O uso é permitido apenas para pessoas com 13 anos ou mais. Usuários menores devem ter consentimento de responsáveis legais.
            </p>

            <h5>Conta de Usuário</h5>
            <p>
                Para acessar recursos da {system}, é necessário criar uma conta com informações verdadeiras e atualizadas. 
                O usuário é totalmente responsável por manter a confidencialidade da senha e por todas as atividades realizadas em sua conta.
            </p>
            <p>
                A {system} não se responsabiliza por acessos não autorizados causados por negligência do usuário.
            </p>

            <h5>Conduta do Usuário</h5>
            <p>Você concorda em não:</p>
            <ul>
                <li>Publicar conteúdo ofensivo, violento, discriminatório, sexual explícito, difamatório ou ilegal.</li>
                <li>Ameaçar, assediar, perseguir ou prejudicar outros usuários.</li>
                <li>Usar bots, automações ou práticas que afetem o funcionamento da plataforma.</li>
                <li>Tentar obter acesso não autorizado a contas ou servidores.</li>
                <li>Distribuir spam, golpes, links maliciosos ou vírus.</li>
            </ul>

            <h5>Remoção de Conteúdo</h5>
            <p>
                A {system} pode remover qualquer conteúdo que viole estes Termos, a qualquer momento, sem aviso prévio.
            </p>

            <h5>Direitos de Propriedade Intelectual</h5>
            <p>
                Todo conteúdo, design, marca, logotipo e código da {system} é protegido por direitos autorais. 
                O usuário não pode copiar, modificar, revender, reproduzir ou distribuir qualquer parte da plataforma sem autorização.
            </p>

            <h5>Conteúdo do Usuário</h5>
            <p>
                Você mantém os direitos do conteúdo que publica. 
                Porém, ao postar na {system}, você concede uma licença não exclusiva, mundial e gratuita para exibir, armazenar, reproduzir e republicar esse conteúdo dentro da plataforma.
            </p>

            <h5>Uso Comercial e Monetização</h5>
            <p>
                Não é permitido usar a {system} para fins comerciais sem autorização, incluindo venda de produtos, serviços ou captação indevida de dados.
            </p>

            <h5>Privacidade e Dados</h5>
            <p>
                O tratamento de dados segue rigorosamente nossa Política de Privacidade. 
                Ao criar uma conta, você autoriza o uso de seus dados conforme descrito.
            </p>

            <h5>Encerramento de Conta</h5>
            <p>
                A {system} pode suspender ou excluir sua conta caso viole estes Termos ou coloque outros usuários em risco.
            </p>

            <h5>Limitação de Responsabilidade</h5>
            <p>
                A {system} não se responsabiliza por perdas, danos indiretos, perda de dados ou falhas causadas pelo uso da plataforma, incluindo quedas temporárias, erros, bugs ou indisponibilidade.
            </p>

            <h5>Isenção sobre Conteúdo de Usuários</h5>
            <p>
                A {system} não se responsabiliza por opiniões, publicações, fotos, vídeos ou qualquer conteúdo criado por usuários.
            </p>

            <h5>Trabalho Voluntário</h5>
            <p>
                Toda moderação, desenvolvimento e colaboração na plataforma é realizada de forma voluntária, sem qualquer expectativa de pagamento.
            </p>

            <h5>Fase Beta de Desenvolvimento</h5>
            <p>
                A {system} está em fase beta, podendo apresentar bugs, falhas e instabilidade. 
                O usuário concorda e aceita estes riscos ao utilizar a plataforma.
            </p>

            <h5>Base Legal do Tratamento de Dados</h5>
            <p>
                O tratamento ocorre com base no consentimento, execução contratual, obrigações legais e outras hipóteses previstas na LGPD.
            </p>

            <h5>Política de Cookies</h5>
            <p>
                Utilizamos cookies para melhorar experiência, personalizar conteúdo e analisar tráfego. 
                Você pode desativá-los nas configurações do navegador.
            </p>

            <h5>Encarregado de Dados (DPO)</h5>
            <p>
                Contato do DPO: <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>
            </p>

            <h5>Transferência Internacional</h5>
            <p>
                Caso haja transferência de dados para fora do Brasil, serão aplicadas salvaguardas conforme a LGPD.
            </p>

            <h5>Medidas de Segurança</h5>
            <p>
                Implementamos criptografia, controle de acesso e auditorias. 
                Apesar disso, não é possível garantir segurança absoluta.
            </p>

            <h5>Atualizações e Notificações</h5>
            <p>
                Qualquer mudança será notificada ao usuário via plataforma ou e-mail.
            </p>

            <h5>Política de Segurança Infantil e Proteção contra CSAE</h5>
            <p>
                A <strong>{system}</strong> adota tolerância zero em relação a qualquer forma de 
                <strong> abuso e exploração sexual infantil (CSAE)</strong>. 
                É expressamente proibido utilizar a plataforma para criar, publicar, compartilhar, 
                armazenar ou promover qualquer conteúdo que envolva crianças ou adolescentes de forma sexual, 
                explícita ou sugestiva.
            </p>

            <p>
                São estritamente proibidos na <strong>{system}</strong>, incluindo, mas não se limitando a:
            </p>

            <ul>
                <li>Abuso sexual de crianças ou adolescentes;</li>
                <li>Exploração sexual infantil;</li>
                <li>Nudez ou conteúdo sexual envolvendo menores;</li>
                <li>Representações, animações, ilustrações ou textos com teor sexual envolvendo menores;</li>
                <li>Aliciamento, assédio, grooming ou qualquer tentativa de aproximação sexual com menores;</li>
                <li>Tráfico, exploração ou incentivo a práticas ilegais envolvendo crianças.</li>
            </ul>

            <p>
                Caso qualquer conteúdo que viole esta política seja identificado ou denunciado, a 
                <strong>{system}</strong> poderá remover o material imediatamente, 
                suspender ou banir permanentemente as contas envolvidas, sem aviso prévio.
            </p>

            <p>
                Quando aplicável, conteúdos e usuários que violem esta política poderão ser 
                <strong>reportados às autoridades competentes</strong>, conforme a legislação vigente.
            </p>

            <p>
                A <strong>{system}</strong> reforça seu compromisso com a 
                <strong>segurança infantil</strong>, adotando medidas preventivas, 
                moderação de conteúdo, análise de denúncias e ações corretivas para proteger 
                crianças e adolescentes dentro da plataforma.
            </p>

            <p>
                Usuários podem denunciar conteúdos ou comportamentos suspeitos através dos 
                mecanismos internos da plataforma ou pelo e-mail:
                <a href="mailto:pacocaredesocial@gmail.com"> pacocaredesocial@gmail.com</a>.
            </p>


            <hr className="mt-3 mb-3"/>
            <h2>Política de Privacidade da {system}</h2>
            <p>Última atualização: 12/09/2024</p>

            <h5>Informações Coletadas</h5>
            <p>
                Coletamos nome, e-mail, telefone, foto de perfil e informações fornecidas voluntariamente.
            </p>

            <h5>Uso das Informações</h5>
            <ul>
                <li>Operar e melhorar a plataforma;</li>
                <li>Personalizar conteúdo;</li>
                <li>Enviar notificações;</li>
                <li>Garantir segurança;</li>
                <li>Cumprir obrigações legais.</li>
            </ul>

            <h5>Compartilhamento</h5>
            <p>
                Não vendemos dados. Compartilhamos apenas quando necessário para cumprir a lei ou operar serviços essenciais.
            </p>

            <h5>Segurança</h5>
            <p>
                Utilizamos criptografia e controles de acesso, mas não garantimos segurança absoluta.
            </p>

            <h5>Retenção</h5>
            <p>
                Mantemos seus dados enquanto sua conta estiver ativa ou conforme exigido por lei.
            </p>

            <h5>Direitos do Usuário</h5>
            <p>
                Você pode acessar, corrigir, excluir, transferir ou retirar consentimento dos seus dados.
            </p>

            <h5>Cookies</h5>
            <p>
                Cookies são usados para personalização e análise de tráfego.
            </p>

            <h5>Contato</h5>
            <p>
                Dúvidas: <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>.
            </p>
        </div>
    )
}

export default GuidelinesText;
